export default {
  routeName: "Onboarding",
  routeValue: "ONB",
};
